module.exports = __webpack_public_path__ + "img/droid-sans-dark.ca78c224.png";